import { InputType } from '@/types';
import isInputEmpty from '@/utils/isInputEmpty';

import type { IInput } from '@/types';

/**
 * Builds the webhook `params` map from the form inputs.
 *
 * An `optional` input the user left empty is omitted entirely rather than sent as
 * a blank value, so the flow applies its own default instead of receiving an empty
 * string / undefined url. Required inputs are always included — by Generate time
 * `isFormValid` has already guaranteed they're filled.
 */
const buildParamsFromInputs = (
  inputs: IInput[] | null
): Record<string, unknown> => {
  if (!inputs) return {};

  return inputs.reduce<Record<string, unknown>>((acc, input) => {
    if (input.optional && isInputEmpty(input)) return acc;

    const key = input.paramKey ?? input.id;
    switch (input.type) {
      case InputType.TEXT:
        return { ...acc, [key]: { value: input.value } };
      case InputType.IMAGE:
      case InputType.VIDEO:
        return {
          ...acc,
          [key]: { url: input.src },
        };
      default:
        return acc;
    }
  }, {});
};

export default buildParamsFromInputs;
